import * as React from "react";
import { observer } from "mobx-react";
import { useContext, useState, useEffect } from "react";
import { ContactViewStoreContext } from "../../context/store";
import { Form, Spin } from "antd";
import { RouteComponentProps } from "react-router-dom";
import { WeddingDateFormItem } from "../molecules/WeddingDateFormItem";
import { MainNameFormItem } from "../molecules/MainNameFormItem";
import { SubNameFormItem } from "../molecules/SubNameFormItem";
import { css } from "@emotion/core";
import { title } from "../../style/header";
import { ArrowLink } from "../atoms/ArrowLink";
import { medium } from "../../style/button";
import { FixedFooter } from "../atoms/FixedFooter";
import { arrowLinkContainer } from "../../style/layout";
import { Footer } from "../organisms/Footer";
import { Check } from "../atoms/Check";
import { track } from "../../services/track";

export const InquiryContact1 = observer(({ history }: RouteComponentProps) => {
  const store = useContext(ContactViewStoreContext);

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    track(
      "ViewContent",
      {
        customData: {
          contentName: "inquiry",
        },
      },
      {
        content_name: "inquiry",
      }
    );
  }, []);

  return (
    <div>
      <h3 css={title}>資料請求・お見積り</h3>
      <Form
        labelCol={{ xs: { span: 24 }, sm: { span: 8 } }}
        wrapperCol={{ xs: { span: 24 }, sm: { span: 12 } }}
      >
        <WeddingDateFormItem />
        <MainNameFormItem />
        <SubNameFormItem />
      </Form>
      <div
        css={css`
          margin-bottom: 30px;
          max-width: 460px;
          margin-left: auto;
          margin-right: auto;
          display: flex;
          justify-content: space-around;
        `}
      >
        <div>
          <span
            onClick={() => {
              store.useWeddingGift = !store.useWeddingGift;
            }}
            css={css`
              position: relative;
              margin-right: 25px;
              background: #fff;
            `}
          >
            <Check checked={store.useWeddingGift} />
          </span>
          引き出物
        </div>
        <div>
          <span
            onClick={() => {
              store.usePrivateGift = !store.usePrivateGift;
            }}
            css={css`
              position: relative;
              margin-right: 25px;
              background: #fff;
            `}
          >
            <Check checked={store.usePrivateGift} />
          </span>
          内祝い
        </div>
      </div>
      <div css={arrowLinkContainer}>
        <ArrowLink to="/signup" direction="left">
          お申し込み希望の方はこちら
        </ArrowLink>
      </div>
      <Footer />
      <FixedFooter>
        <button
          css={medium}
          disabled={loading}
          onClick={() => {
            if (!store.hasBasicContactInfo) {
              alert("すべての項目を埋めてください");
              return;
            }

            setLoading(true);

            // リロードを避けるため、匿名ユーザーを作る前にstoreをinitialized扱いにする。
            store.initialized = true;

            // 必要があれば匿名ユーザーを作成し、次の画面へ遷移
            store.signInAnonymouslyIfNeeded().then(
              () => {
                // TODO: この雑な処理やめる。
                // NOTE: この時点では、sessionStatusがまだloggedOutなんじゃないかと思ってる。
                setTimeout(() => {
                  history.push("/inquiry/contact2");
                }, 100);
              },
              (_) => {
                alert("エラーが発生しました。");
                setLoading(false);
              }
            );
          }}
        >
          OK
          {loading && <Spin size="small" />}
        </button>
        <ArrowLink to="/" direction="left" external={true} />
      </FixedFooter>
    </div>
  );
});
